import {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {createProduct, getCategories} from '../api/productApi';
import { isLoggedIn } from '../utils/tokenUtils';
import styles from './ProductCreatePage.module.css';

function ProductCreatePage()
{
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [form, setform] = useState({
        categoryId: '',
        name: '',
        description: '',
        price: '',
        stock: '',
    });
    const [imageFile,setImageFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(!isLoggedIn())
        {
            alert('로그인이 필요합니다.');
            navigate('/login');
            return;
        }
        loadCategories();
    },[]);

    const loadCategories = async() =>
    {
        try
        {
            const response = await getCategories();
            setCategories(response.data);
        }
        catch (err)
        {
            console.error('카테고리 로딩 실패', err);
        }
    };

    const handleChange = (e) => 
    {
        setform({...form, [e.target.name]:e.target.value});
    };

    const handleImageChange = (e) =>
    {
        const file = e.target.files[0];
        if(!file) return;
        setImageFile(file);
        setPreview(URL.createObjectURL(file));
    };

    const handleSubmit = async (e) =>
    {
        e.preventDefault();
        setError('');

        if(!form.categoryId) return setError('카테고리를 선택해주세요.');
        if(!form.name.trim()) return setError('상품명을 입력해주세요');
        if(!form.price) return setError('가격을 입력해주세요.');
        if(!form.stock) return setError('재고를 입력해주세요.');

        try
        {
            setLoading(true);
            const formData = new FormData();
            formData.append('categoryId', form.categoryId);
            formData.append('name', form.name);
            formData.append('description', form.description);
            formData.append('price', form.price);
            formData.append('stock', form.stock);
            if(imageFile) formData.append('imageFile', imageFile);

            await createProduct(formData);
            alert('상품이 등록되었습니다.');
            navigate('/products');
        }
        catch (err)
        {
            setError('상품 등록에 실패했습니다.');
        }
        finally
        {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>상품 등록</h2>

            <form onSubmit={handleSubmit} className={styles.form}>
                {/* 이미지 업로드 */}
                <div className={styles.imageUpload}>
                    <label className={styles.imageLabel}>
                        {preview ? (
                            <img src={preview} alt="미리보기" className={styles.preview} />
                        ) : (
                            <div className={styles.imagePlaceholder}>
                                <span>+ 이미지 추가</span>
                            </div>
                        )}
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className={styles.fileInput}
                        />
                    </label>
                </div>

                {/* 카테고리 */}
                <div className={styles.field}>
                    <label className={styles.label}>카테고리</label>
                    <select
                        name="categoryId"
                        value={form.categoryId}
                        onChange={handleChange}
                        className={styles.select}
                    >
                        <option value="">카테고리 선택</option>
                        {categories.map((cat) => (
                            <option key={cat.categoryId} value={cat.categoryId}>
                                {cat.parentName ? `${cat.parentName} > ${cat.name}` : cat.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* 상품명 */}
                <div className={styles.field}>
                    <label className={styles.label}>상품명</label>
                    <input
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        className={styles.input}
                        placeholder="상품명을 입력하세요"
                    />
                </div>

                {/* 설명 */}
                <div className={styles.field}>
                    <label className={styles.label}>상품 설명</label>
                    <textarea
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                        className={styles.textarea}
                        placeholder="상품 설명을 입력하세요"
                        rows={4}
                    />
                </div>

                {/* 가격 */}
                <div className={styles.field}>
                    <label className={styles.label}>가격</label>
                    <input
                        type="number"
                        name="price"
                        value={form.price}
                        onChange={handleChange}
                        className={styles.input}
                        placeholder="가격을 입력하세요"
                        min="0"
                    />
                </div>

                {/* 재고 */}
                <div className={styles.field}>
                    <label className={styles.label}>재고</label>
                    <input
                        type="number"
                        name="stock"
                        value={form.stock}
                        onChange={handleChange}
                        className={styles.input}
                        placeholder="재고를 입력하세요"
                        min="0"
                    />
                </div>

                {error && <p className={styles.error}>{error}</p>}

                <button type="submit" className={styles.submitButton} disabled={loading}>
                    {loading ? '등록 중...' : '상품 등록'}
                </button>
            </form>
        </div>
    );
}

export default ProductCreatePage;